import { Component } from '@angular/core';

@Component({
    selector: 'app-password-changed-page',
    templateUrl: './password-changed-page.component.html',
    styleUrls: ['../../pages.scss', './password-changed-page.component.scss'],
})
export class PasswordChangedPageComponent {}
